import React from "react";
import { Collapse } from 'reactstrap';
import './menuIten.css'
import { NavLink } from "react-router-dom";

/**
 * Os itens vem do APP.js SideDrawer.js via props
 * pode ser um array de itens para montar um dropdown ou iten unico
 * Item unico utiliza, title, key icon e enabled
 */

const toggle = (id, closed) => {
    console.log('toggle', id)
    let setVisible = true
    var els = document.getElementsByClassName('menu-iten');
    var arrows = document.getElementsByClassName('menu-icon-arrow');
    // console.log(els.length)
    for (let i = 0; i < els.length; i++) {
        // console.log(i, els[i].classList.value)
        if (els[i].classList.value.includes('show')) {
            if(closed && els[i].id === id) return 
            if (els[i].id === id) {
                setVisible = false
                console.log('cai aq')
                els[i].classList.remove('show')
            }
            els[i].classList.remove('show')
        }
    }

    for (let i = 0; i < arrows.length; i++) {
        if (arrows[i].classList.value.includes('arrow-icon-open')) {
            arrows[i].classList.remove('arrow-icon-open')
        }
    }




    if (setVisible) {
        // console.log('open')
        localStorage.setItem('menuIten', true)
        if (document.getElementById(id)) document.getElementById(id).classList.add('show');
        document.getElementById(`arrow-${id}`).classList.add('arrow-icon-open');
    } else {
        // console.log('close')
        localStorage.setItem('menuIten', false)

    }

}


let path = '/'
const handleClickmenu = (key, id, call, pageTitle) => {
    var indicator = document.getElementsByClassName('menu-iten-active')
    console.log('clic')
    // indicator[0].classList.add('hide');

    // document.getElementById(`indicator-${id}`).classList.add('show');
    // console.log(`ou = indicator-${id}`)
    // console.log(document.getElementById(`indicator-${id}`))

    path = window.location.pathname

    //Setar o page Title
    document.title = pageTitle

    //Height Toolbar
    setTimeout(() => {
        call()
    }, 250);

    if (path.indexOf(key) > 0) return
    else {
        //menu-iten-link-container
        var elements = document.getElementsByClassName('menu-iten-link-container ');
        for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove('active')
            // console.log(elements[i])
        }
        for (let i = 0; i < indicator.length; i++) {
            indicator[i].classList.remove('show');
            indicator[i].classList.add('hide');

        }
        document.getElementById(`dropdown-${id}`).classList.add('active');
        document.getElementById(`indicator-${id}`).classList.add('show');
    }
  

}

const MenuIten = props => {
    path = window.location.href
    // console.log(props.data)
    // console.log('menuIten', JSON.parse(localStorage.getItem("menuIten")))
    const menuIten = JSON.parse(localStorage.getItem("menuIten"))
    // console.log(props.data)
    return checkModules(props.data.modules, props.clientModules) ? (
        (
            props.drawerOpen ? (
                <div>
                    {props.data.dropdown ? (
                        <div
                            className={`menu-iten-link-container ${!props.data.enable ? 'disabled' : ''} ${path.indexOf(props.data.key) > 0 ? "active" : ''}`} onClick={() => props.data.enable ? toggle(props.id, false) : false}
                            id={`dropdown-${props.id}`}>


                            <div className={`menu-iten-active ${path.indexOf(props.data.key) > 0 ? 'show' : 'hide'}`} id={`indicator-${props.id}`} />


                            <div className='menu-iten-icon'>
                                <div style={{ backgroundImage: `url('${props.data.icon}')` }} className='menu-icon-iten' />
                            </div>


                            <div className='menu-iten-label'>
                                <span>{props.data.title}</span>
                            </div>


                            <div className='menu-iten-arrow'>
                                <div className={`menu-icon-arrow chevron-down-icon ${path.indexOf(props.data.key) > 0 && menuIten ? "arrow-icon-open" : ''}`} id={`arrow-${props.id}`} style={{ display: props.data.dropdown ? 'block' : 'none' }} />
                            </div>
                        </div>

                    ) : (
                        <NavLink
                            // activeStyle={{backgroundColor: 'red'}}
                            activeClassName="active"
                            className="link-dropdown"
                            to={props.data.enable ? props.data.key : '#'}
                            onClick={() => props.data.enable ? handleClickmenu(props.data.key, props.id, props._updateDimensions, props.data.title) : false}

                        >
                            <div
                                className={`menu-iten-link-container ${!props.data.enable ? 'disabled' : ''} ${path.indexOf(props.data.key) > 0 ? "active" : ''}`} onClick={() => props.data.enable ? toggle(props.id, false) : false}
                                id={`dropdown-${props.id}`}>
                                    
                                <div className={`menu-iten-active ${path.indexOf(props.data.key) > 0 ? 'show' : 'hide'}`} id={`indicator-${props.id}`} />

                                <div className='menu-iten-icon'>
                                    <div style={{ backgroundImage: `url('${props.data.icon}')` }} className='menu-icon-iten' />
                                </div>


                                <div className='menu-iten-label'>
                                    <span>{props.data.title}</span>
                                </div>


                                <div className='menu-iten-arrow'>
                                    <div className={`menu-icon-arrow chevron-down-icon ${path.indexOf(props.data.key) > 0 && menuIten ? "arrow-icon-open" : ''}`} id={`arrow-${props.id}`} style={{ display: props.data.dropdown ? 'block' : 'none' }} />
                                </div>
                            </div>
                        </NavLink>
                    )}

                    {props.data.dropdown ? (
                        <Collapse className={`menu-iten fade-in ${path.indexOf(props.data.key) > 0 && menuIten ? "show" : ''}`} id={props.id}>
                            {
                                props.data.dropdownItens.map((d, i) => {
                                    return props.clientModules.includes(d.module) ? (
                                        <div key={i} className='dropown-menu'>
                                            {/* <span>{d.label}</span> */}
                                            {d.enable ? (
                                                <NavLink
                                                    // activeStyle={{backgroundColor: 'red'}}
                                                    activeClassName="active"
                                                    className="link-dropdown"
                                                    to={d.value}
                                                    onClick={() => handleClickmenu(props.data.key, props.id, props._updateDimensions, d.label)}

                                                >
                                                    {d.label}
                                                </NavLink>
                                            ) : (
                                                <span className="link-dropdown disabled">{d.label}</span>
                                            )}
                                        </div>
                                    ) : null
                                })
                            }
                        </Collapse>

                    ) : null}

                </div>
            ) : (
                <div 
                className={`menu-iten-link-container drawer-close ${!props.data.enable ? 'disabled' : ''} ${path.indexOf(props.data.key) > 0 ? "active" : ''}`} 
                onClick={() => {
                    if(props.data.enable) {
                        props._toggleDrawer()
                        setTimeout(() => {
                            toggle(props.id, true)
                        }, 400);
                    }
                }}>
                    <div className='menu-iten-icon drawer-close'>
                        <div className={`menu-iten-active ${path.indexOf(props.data.key) > 0 ? 'show' : 'hide'}`} id={`indicator-${props.id}`} />
                        <div style={{ backgroundImage: `url('${props.data.icon}')` }} className={`menu-icon-iten drawer-close `} />
                    </div>
                </div>
            )
        )
    ) : null
}


const checkModules = (toCheck, modules) => {

    // console.log(toCheck, modules)
    let show = false;
    toCheck.forEach(d => {
        //   console.log(d)
        modules.forEach(element => {
            // console.log(element.module)
            if (d === element) {
                // console.log('cai aq')
                show = true
            }
        });
    });
    // console.log('show do')
    return show
}



export default MenuIten;